import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { PlusOutlined } from "@ant-design/icons";
import { useNavModel } from "@/model/navModel";
import { assetsListModel } from "../assetsListModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { TransferLogModal } from "./transferLogModel";
import { GoodsTransferModal } from "./goodsTransferModel";
import { ChangeWarehouseModel } from './ChangeWarehouseModel'

export const DataBox = () => {
    const {
        //  loadData,
        setGoodsTransferVisible,
        setTransferLogVisible,
        selectedIdKeys, setSelectedIdKeys,
        selectedRowKeys, setSelectedRowKeys,
        exportData } = assetsListModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const goodsTransfer = () => {
        setGoodsTransferVisible(true)
    }
    const transferLog = () => {
        setTransferLogVisible(true)
    }
    const [changeWarehouseVisible, setChangeWarehouseVisible] = useState(false)

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_LIST_EX}>
            <Button
                className="mr-5"
                shape="round"
                onClick={exportData}
                type="primary"
            >导出</Button>
        </YhAuth>
        <Button
            className="mr-5"
            shape="round"
            onClick={goodsTransfer}
            type="primary"
        >货位转移</Button>
        <Button
            className="mr-5"
            shape="round"
            onClick={transferLog}
            type="primary"
        >转移记录</Button>
        {/* <Button
            className="mr-5"
            shape="round"
            onClick={() => setChangeWarehouseVisible(true)}
            type="primary"
        >仓库货位批量转移</Button> */}
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
            <TransferLogModal />
            <GoodsTransferModal />
            <ChangeWarehouseModel  visible={changeWarehouseVisible} setVisible={setChangeWarehouseVisible} />
        </YhBox>
    )
}
